export type NotificationType = 'success' | 'error';

export interface Notification {
  type: NotificationType;
  message: string;
  errors?: string;
  focusItem?: Element | null;
  focusRequired?: boolean;
  tab?: number;
}
